module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA9.a753b264.jpg";